import { Button, Dialog, DialogActions, DialogTitle, DialogContent, List, ListItem, ListItemText, Typography, Grid } from "@mui/material";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import theme from "../../../../theme";
const DeleteUsersModal = ({ open, user, close, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={() => close()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }} id="alert-dialog-title">Borrar usuario:
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>¿Seguro desea eliminar este usuario?</Typography>
          </Grid>
          <List sx={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {
                <ListItem>
                  <ListItemText><FiberManualRecordIcon color={'secondary'} sx={{ paddingTop: '8px' }} fontSize='small'/>Persona ID: {user?.personaId} -
                    {user?.personaFisica ? user?.nombre + ' ' + user?.apellido : user?.denominacionSocial} ({user?.roles}) </ListItemText>
                </ListItem>
            }
          </List>
        </Grid>
      </DialogContent>
      <DialogActions >
        <Button  sx={{fontWeight: "bold"}} variant="outlined" onClick={() => close()}>Cancelar</Button>
        <Button sx={{fontWeight: "bold", color: "white"}} variant="contained" autoFocus onClick={() => {onConfirm(); close()}}>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )
};
export default DeleteUsersModal;
